// Mock data for Big Dog Kush website

export const strains = [
  {
    id: 1,
    name: "Frostbite OG",
    type: "Indica Dominant Hybrid",
    description: "Top-shelf exotic gas certified by Hustleking Empire. Sealed fresh, icy nugs, heavy pressure.",
    tagline: "So cold it bite back",
    flavor: "Icy gas, frosty kush, heavy pressure",
    image: "https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/ocbsreeg_IMG_0955.jpeg",
    pricing: {
      "5g": 30,
      "10g": 50,
      "half": 65,
      "zip": 120
    },
    effects: ["Relaxing", "Heavy", "Euphoric"],
    bestFor: "Evening sessions, stress relief, heavy relaxation",
    category: "flower",
    featured: true
  },
  {
    id: 2,
    name: "JuiceWorld Kush",
    type: "Hybrid (Indica-leaning)",
    description: "Euphoric head high followed by a calming, relaxing body buzz. Perfect for stress relief and evening vibes.",
    tagline: "Sweet fruit, creamy kush, light gas",
    flavor: "Sweet fruit, creamy kush, light gas",
    image: "https://customer-assets.emergentagent.com/job_kushportal/artifacts/jmor5o2c_IMG_0959.jpeg",
    pricing: {
      "5g": 35,
      "10g": 60,
      "half": 75,
      "zip": 140
    },
    effects: ["Euphoric", "Calming", "Smooth"],
    bestFor: "Stress relief, evening vibes, chill sessions",
    category: "flower",
    featured: true
  },
  {
    id: 3,
    name: "Black Diamond Kush",
    type: "Indica-dominant",
    description: "Deep body relaxation and stress relief with couch-locking calm. Perfect for unwinding after long days.",
    flavor: "Earthy pine, sweet grape, subtle spice",
    image: "https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/073rv4fg_IMG_0828.jpeg",
    pricing: {
      "5g": 40,
      "10g": 70,
      "half": 85,
      "zip": 150
    },
    effects: ["Deep Relaxation", "Stress Relief", "Couch-lock"],
    bestFor: "Nighttime use, pain relief, sleep, unwinding after long days",
    category: "flower",
    featured: false
  },
  {
    id: 4,
    name: "Frosted Pine Kush",
    type: "Hybrid (Indica-leaning)",
    description: "Smooth head relaxation with full-body calm. Perfect for evening sessions and stress relief.",
    flavor: "Fresh pine, creamy kush, light citrus",
    pricing: {
      "5g": 38,
      "10g": 65,
      "half": 80,
      "zip": 135
    },
    effects: ["Head Relaxation", "Body Calm", "Smooth"],
    bestFor: "Evening sessions, stress relief, mellow focus",
    category: "flower",
    featured: false
  },
  {
    id: 5,
    name: "Kush & Cream",
    type: "Hybrid",
    description: "Uplifting start followed by relaxing body effects. Great for social vibes and stress relief.",
    flavor: "Sweet vanilla, creamy kush, light gas",
    pricing: {
      "5g": 42,
      "10g": 75,
      "half": 90,
      "zip": 145
    },
    effects: ["Uplifting", "Relaxing", "Social"],
    bestFor: "Social vibes, stress relief, anytime smoke",
    category: "flower",
    featured: false
  },
  {
    id: 6,
    name: "Royal Runtz Kush",
    type: "Hybrid",
    description: "Euphoric head high with smooth body relaxation. Perfect for chill vibes and social smoking.",
    flavor: "Fruity candy, sweet gas, kush finish",
    pricing: {
      "5g": 45,
      "10g": 80,
      "half": 95,
      "zip": 150
    },
    effects: ["Euphoric", "Smooth", "Social"],
    bestFor: "Chill vibes, social smoking, stress relief",
    category: "flower",
    featured: false
  },
  {
    id: 7,
    name: "Platinum Frost Kush",
    type: "Indica-dominant",
    description: "Heavy relaxation with calming mind and full-body melt. Perfect for deep relaxation and sleep support.",
    flavor: "Frosty pine, gas, earthy kush",
    pricing: {
      "5g": 47,
      "10g": 85,
      "half": 100,
      "zip": 150
    },
    effects: ["Heavy Relaxation", "Calming", "Full-body Melt"],
    bestFor: "Nighttime, sleep support, deep relaxation",
    category: "flower",
    featured: false
  },
  {
    id: 8,
    name: "Kush & Kandy",
    type: "Hybrid",
    description: "Happy, euphoric, calming without heavy sedation. Great for mood boost and creative sessions.",
    flavor: "Sweet candy, fruity kush, light gas",
    pricing: {
      "5g": 40,
      "10g": 72,
      "half": 88,
      "zip": 142
    },
    effects: ["Happy", "Euphoric", "Calming"],
    bestFor: "Mood boost, creative sessions, day or night",
    category: "flower",
    featured: false
  },
  {
    id: 9,
    name: "Banana OG",
    type: "Indica-dominant Hybrid",
    description: "Sweet tropical banana flavors meet classic OG genetics for a smooth, relaxing experience.",
    flavor: "Sweet banana, tropical fruit, earthy OG",
    pricing: {
      "5g": 35,
      "10g": 65,
      "half": 50,
      "zip": 80
    },
    effects: ["Relaxing", "Euphoric", "Tropical"],
    bestFor: "Evening relaxation, stress relief, fruity flavor lovers",
    category: "flower",
    featured: false
  },
  {
    id: 10,
    name: "Apple Jack",
    type: "Sativa-dominant Hybrid",
    description: "Crisp apple flavors with energizing effects. Perfect balance of sweet fruit and uplifting buzz.",
    flavor: "Fresh apple, sweet fruit, light spice",
    pricing: {
      "5g": 35,
      "10g": 65,
      "half": 50,
      "zip": 80
    },
    effects: ["Energizing", "Uplifting", "Crisp"],
    bestFor: "Daytime use, creative projects, mood elevation",
    category: "flower",
    featured: false
  },
  {
    id: 11,
    name: "OG London Pound Cake",
    type: "Indica-dominant Hybrid",
    description: "Rich dessert flavors with potent OG effects. Sweet vanilla cake meets gassy OG finish.",
    flavor: "Sweet vanilla cake, creamy dessert, gassy OG",
    pricing: {
      "5g": 35,
      "10g": 65,
      "half": 50,
      "zip": 80
    },
    effects: ["Potent", "Relaxing", "Dessert"],
    bestFor: "Evening sessions, dessert lovers, heavy relaxation",
    category: "flower",
    featured: false
  }
];

export const categories = [
  { id: 1, name: "All Products", slug: "all" },
  { id: 2, name: "Flower", slug: "flower" },
  { id: 3, name: "Pre-Rolls", slug: "pre-rolls" },
  { id: 4, name: "Concentrates", slug: "concentrates" },
  { id: 5, name: "Edibles", slug: "edibles" },
  { id: 6, name: "Vaporizers", slug: "vapes" },
  { id: 7, name: "Accessories", slug: "accessories" }
];

export const filterOptions = [
  {
    id: "category",
    name: "Category",
    options: [
      { value: "all", label: "All Products" },
      { value: "flower", label: "Flower" },
      { value: "pre-rolls", label: "Pre-Rolls" },
      { value: "concentrates", label: "Concentrates" },
      { value: "edibles", label: "Edibles" }
    ]
  },
  {
    id: "type",
    name: "Type",
    options: [
      { value: "all", label: "All Types" },
      { value: "indica", label: "Indica" },
      { value: "sativa", label: "Sativa" },
      { value: "hybrid", label: "Hybrid" }
    ]
  },
  {
    id: "featured",
    name: "Featured",
    options: [
      { value: "all", label: "All Products" },
      { value: "featured", label: "Featured Only" }
    ]
  }
];

export const promoOffers = [
  {
    id: 1,
    title: "New Customer Special",
    description: "25% off your first order",
    code: "WELCOME25",
    validUntil: "2024-02-15"
  },
  {
    id: 2,
    title: "Weekend Warriors",
    description: "Special pricing on select strains",
    code: "WEEKEND",
    validUntil: "2024-02-10"
  }
];

export const businessInfo = {
  name: "Big Dog Kush",
  phone: "(945) 545-7553",
  textNumber: "(945) 545-7553",
  email: "hello@bigdogkush.com",
  location: "Dallas, TX",
  socialHandle: "@Hustlegoodmotion5",
  hours: {
    "Monday-Saturday": "9AM-10PM",
    "Sunday": "10AM-8PM"
  },
  serviceArea: "Dallas Metro Area",
  disclaimer: "For adults 21+. Products subject to local laws and availability."
};